import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as api from "../../../firebase/api";
import { bannerVariablesCollectionKey } from "../../../firebase/api";
import {
    deleteBannerVariablesAsyncActions,
    fetchBannerVariablesAsyncActions,
    fetchBannerVariablesByIdAsyncActions,
    modifiedActiveBannerVariablesAction,
    modifyingActiveBannerVariablesAction,
    saveBannerVariablesAsyncActions,
    setMasterActiveBannerVariablesAction
} from "./actions";
import {
    DesignVariablesKeyInCustomCode,
    FeedPostVariablesKeyInCustomCode,
    FeedPreVariablesKeyInCustomCode,
    IVariablesFormFields
} from "../../../components/BannerEditor/VariablesForm";
import { createSelectActiveBannerVariables, createSelectParentOfBannerVariables, } from "./selectors";
import { isArray, isObject, merge, mergeWith } from 'lodash'
import { modifyingActiveBannerTemplateAction } from "../template/actions";
import { selectActiveBannerTemplate } from "../template/selectors";
import { getType } from "typesafe-actions";
import { IBannerVariables, VariablesType } from "./types";
import { IBannerTemplate } from "../template/types";


function* fetchBannerVariablesByIdSaga(action: ReturnType<typeof fetchBannerVariablesByIdAsyncActions.request>) {
    try {
        // @ts-ignore
        const data = yield call(api.fetchDocById, bannerVariablesCollectionKey, action.payload.id);

        yield put(fetchBannerVariablesByIdAsyncActions.success({ bannerVariables: data }));
    } catch (e) {
        // @ts-ignore
        yield put(fetchBannerVariablesByIdAsyncActions.failure({ error: e }));
    }
}

function* fetchBannerVariablesSaga(action: ReturnType<typeof fetchBannerVariablesAsyncActions.request>) {
    try {
        // @ts-ignore
        const data = yield call(api.fetchCollection, bannerVariablesCollectionKey);
        yield put(fetchBannerVariablesAsyncActions.success({ bannerVariablesList: data }));
    } catch (e) {
        // @ts-ignore
        yield put(fetchBannerVariablesAsyncActions.failure({ error: e }));
    }
}
function* saveBannerVariablesSaga(action: ReturnType<typeof saveBannerVariablesAsyncActions.request>) {
    try {
        // @ts-ignore
        const data = yield call(api.saveDocToCollection, bannerVariablesCollectionKey, action.payload.bannerVariables);
        yield put(saveBannerVariablesAsyncActions.success({ bannerVariables: data }));
        const { variablesType } = action.payload.bannerVariables;
        if (variablesType === VariablesType.DESIGN) {
            yield put(modifyingActiveBannerTemplateAction({ bannerTemplate: { designBannerVariablesId: data.id } }))
        } else if (variablesType === VariablesType.FEED) {
            yield put(modifyingActiveBannerTemplateAction({ bannerTemplate: { feedBannerVariablesId: data.id } }))
        }

    } catch (e) {
        // @ts-ignore
        yield put(saveBannerVariablesAsyncActions.failure({ error: e }))
    }
}
function* deleteBannerVariablesSaga(action: ReturnType<typeof deleteBannerVariablesAsyncActions.request>) {
    try {
        yield call(api.deleteDocById, bannerVariablesCollectionKey, action.payload.id);
        yield put(deleteBannerVariablesAsyncActions.success({ id: action.payload.id }))
    } catch (e) {
        // @ts-ignore
        yield put(deleteBannerVariablesAsyncActions.failure({ error: e }))
    }
}
// todo exploring waiting for put https://github.com/redux-saga/redux-saga/issues/886
function* modifyBannerVariablesSaga(action: ReturnType<typeof modifyingActiveBannerVariablesAction>) {
    // @ts-ignore
    const oldActiveBannerVariables = yield select(createSelectActiveBannerVariables, action.payload.variablesType, false);

    const activeBannerVariables = merge({}, oldActiveBannerVariables, action.payload.bannerVariables);
    yield put(modifiedActiveBannerVariablesAction(activeBannerVariables))
}

function* modifyingBannerVariablesSaga(action: ReturnType<typeof modifyingActiveBannerVariablesAction>) {
    yield call(modifyBannerVariablesSaga, action);

    const newActiveBannerVariables: IBannerVariables = yield select(createSelectActiveBannerVariables, action.payload.variablesType, false);
    const parentOfActiveBannerVariables: IBannerVariables = yield select(createSelectParentOfBannerVariables, newActiveBannerVariables);
    const activeBannerTemplates: IBannerTemplate = yield select(selectActiveBannerTemplate);

    let variables = newActiveBannerVariables.variables;
    if (parentOfActiveBannerVariables) {
        yield put(setMasterActiveBannerVariablesAction({
            bannerVariables: parentOfActiveBannerVariables,
            variablesType: action.payload.variablesType
        }));
        variables = mergeChildVariablesWithMasterVariables(newActiveBannerVariables, parentOfActiveBannerVariables)
    }

    let code = activeBannerTemplates.customCode;
    if (newActiveBannerVariables.variablesType === VariablesType.FEED) {
        const feedVars = processFeedVariables(variables);
        // const preCC = generateVariablesForCustomCode(FeedPreVariablesKeyInCustomCode, feedVars.preVars);
        // code = code.replace(/(.*#FeedPreVars#\n)([\s\S]*?)(#EndFeedPreVars#.*)/, `$1${preCC}$3`);

        const postCC = generateFeedPostVarsForCustomCode(FeedPostVariablesKeyInCustomCode, feedVars.postVars);
        code = code.replace(/(.*#FeedPostVars#)([\s\S]*?)(#EndFeedPostVars#.*)/, `$1${postCC}$3`)
    }

    yield put(modifyingActiveBannerTemplateAction({ bannerTemplate: { customCode: code } }))
}
const customizer = (objValue: any, srcValue: any, key: string, object: any, source: any, stack: any) => {
    if (objValue && !isObject(objValue) && !isArray(objValue) && srcValue) {
        return srcValue
    }
};

const mergeChildVariablesWithMasterVariables = (child: IBannerVariables, master: IBannerVariables): IVariablesFormFields => {
    return mergeWith({}, master.variables, child.variables, customizer)
};

const processFeedVariables = (variables: IVariablesFormFields | null): { preVars: IVariablesFormFields, postVars: IVariablesFormFields } => {
    let vars = {
        preVars: {},
        postVars: {}
    };
    if (variables) {
        if (variables.pre) {
            vars.preVars = variables.pre
        }
        if (variables.post) {
            vars.postVars = variables.post
        }
    }
    return vars
};

interface IFeedColumns {
    Id?: string;
    Name?: string;
    ImageUrl?: string;
    ClickUrl?: string;
    Price?: string;
    ReducedPrice?: string;
    Sale?: string;
    Description1?: string;
    Description2?: string;
    Description3?: string;
    Description4?: string;
}

export const feedPostCC = (columns: IFeedColumns): string => {
    if (!columns || Object.keys(columns).length == 0) {
        columns = {
            Id: "Id",
            Name: "Name",
            ImageUrl: "ImageUrl",
            ClickUrl: "ClickUrl",
            Price: "Price",
            ReducedPrice: "ReducedPrice",
            Sale: "Sale",
            Description1: "Description1",
            Description2: "Description2",
            Description3: "Description3",
            Description4: "Description4"
        }
    }

    return `
let Offers = FeedOffers.map(fn(x)
    let o = {
        "Id": x.${columns.Id} or "",
        "Name": x.${columns.Name} or "",
        "ImageUrl": x.${columns.ImageUrl} or "",
        "ClickUrl": x.${columns.ClickUrl} or "",
        "Price": x.${columns.Price} or "",
        "ReducedPrice": x.${columns.ReducedPrice} or "",
        "Sale": x.${columns.Sale} or "",
        "Description1": x.${columns.Description1} or "",
        "Description2": x.${columns.Description2} or "",
        "Description3": x.${columns.Description3} or "",
        "Description4": x.${columns.Description4} or ""
    }
end)
`;
}

const generateFeedPostVarsForCustomCode = (key: string, variables: IVariablesFormFields | null): string => {
    let vars = "";
    if (variables) {
        try {
            const v = JSON.parse(JSON.stringify(variables, jsonReplacer));
            if (v.columns) {
                vars = feedPostCC(v.columns)
            }
        } catch (e) {
            console.log(e);
            // @ts-ignore
            vars = `# ${e.toString()}`
        }
    }
    return vars
};

const generateVariablesForCustomCode = (key: string, variables: IVariablesFormFields | null): string => {
    let vars = "";
    if (variables) {

        const v = merge({}, variables);
        // when the value is null, meaning it's deleted
        Object.keys(variables).forEach((key: string) => {
            if (variables[key] === null) {
                delete v[key]
            }
        });
        vars = JSON.stringify(v, jsonReplacer)
    }
    return `let ${key} = ${vars}
`
};

const jsonReplacer = (k: any, v: any) => {
    // Filtering out properties
    if (v && typeof v === "object" && "value" in v) {
        if (v["type"] === "Checkbox") {
            if (!v["value"]) {
                return ""
            } else {
                return " "
            }
        }
        return v["value"]
    }
    return v;
};


function* bannerVariablesActionWatcher() {
    yield takeEvery(fetchBannerVariablesByIdAsyncActions.request, fetchBannerVariablesByIdSaga);
    yield takeLatest(fetchBannerVariablesAsyncActions.request, fetchBannerVariablesSaga);
    yield takeLatest(saveBannerVariablesAsyncActions.request, saveBannerVariablesSaga);
    yield takeEvery(deleteBannerVariablesAsyncActions.request, deleteBannerVariablesSaga);
    yield takeEvery(getType(modifyingActiveBannerVariablesAction), modifyingBannerVariablesSaga)
}

export default bannerVariablesActionWatcher;
